define('utils/form',['jquery'], function($) {
    var DISABLED_ON_SUBMIT = 'disabledOnSubmit';
    return {
        isDisabledOnSubmit: function(form) {
            return $.data(form, DISABLED_ON_SUBMIT);
        },
        disableOnSubmit: function(form) {
            $.data(form, DISABLED_ON_SUBMIT, true);
        },
        enableOnSubmit: function(form) {
            $.data(form, DISABLED_ON_SUBMIT, false);
        },
        disableSelection: function(target) {
            // IE route
            if (typeof target.onselectstart != 'undefined') {
                target.onselectstart = function() {
                    return false;
                };
            }
            // Firefox route
            else if (typeof target.style.MozUserSelect != 'undefined') {
                target.style.MozUserSelect = 'none';
            }
            // All other route (ie: Opera)
            else {
                target.onmousedown = function() {
                    return false;
                };
            }
            target.style.cursor = 'default';
        }
    };
});

